<template>
    <v-app-bar absolute color="transparent" flat height="85">
        <v-container>
            <v-row align="center">
                <v-toolbar-title class="font-weight-light" v-text="title" />

                <v-spacer />

                <v-btn v-for="(item, i) in items" :key="i" :to="item.to" class="hidden-sm-and-down mr-12" min-height="48" text>
                    <v-icon left size="20" v-text="item.icon" />

                    <span v-text="item.text" />
                </v-btn>
                <sdr-appbar-appbox></sdr-appbar-appbox>
            </v-row>
        </v-container>
    </v-app-bar>
</template>

<script>
    import AppBox from '../AppBox.vue';


    export default {
        name: 'PagesCoreAppBar',


        /* >>> *************************************************************** / /* Components */
		components: {

			'sdr-appbar-appbox': AppBox

		}, // eo components{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({
            items: [
                {
                    icon: 'mdi-fingerprint',
                    text: 'Login',
                    to: '/pages/login'
                },
                // {
                //     icon: 'mdi-lock-open-outline',
                //     text: 'Lock',
                //     to: '/' // /pages/lock
                // }
            ],
            titles: {
                '/pages/lock': 'SunCrew2 - Reports - Lock',
                '/pages/login': 'SunCrew2 - Reports - Login'
            }
        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            title () {
                return this.titles[this.$route.path];
            }

        } // eo computed{}
        /* <<< ****************************************************************/
    };
</script>
